import { IconProps } from "./types";
import React from "react";

export const HistoryIcon = ({
  className,
  fill = "currentColor",
  width = 16,
  height = 13,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 16 13"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M8.571 7.71975e-07C6.8661 0.000265962 5.23111 0.677722 4.02566 1.88336C2.8202 3.08901 2.143 4.7241 2.143 6.429H0L2.779 9.208L2.829 9.308L5.714 6.429H3.571C3.56566 5.26567 3.96421 4.13653 4.69862 3.23431C5.43304 2.33209 6.4578 1.71269 7.59801 1.48185C8.73822 1.251 9.92321 1.423 10.9507 1.9685C11.9783 2.514 12.7846 3.39918 13.2322 4.47298C13.6798 5.54677 13.7409 6.74262 13.405 7.85643C13.0691 8.97023 12.3571 9.93296 11.3905 10.5803C10.4239 11.2276 9.26263 11.5195 8.10483 11.406C6.94704 11.2925 5.86451 10.7807 5.042 9.958L4.029 10.971C4.77638 11.7186 5.69663 12.2703 6.70819 12.5772C7.71975 12.8841 8.79139 12.9367 9.82817 12.7305C10.8649 12.5242 11.8348 12.0654 12.6519 11.3947C13.469 10.724 14.108 9.86213 14.5124 8.88543C14.9167 7.90873 15.0739 6.84737 14.97 5.79539C14.8662 4.74341 14.5044 3.7333 13.9168 2.85455C13.3292 1.97581 12.534 1.25557 11.6015 0.757641C10.669 0.259716 9.62809 -0.000517285 8.571 7.71975e-07ZM7.857 3.571V7.142L10.914 8.956L11.428 8.092L8.928 6.606V3.571H7.857Z"
      fill={fill}
    />
  </svg>
);
